import "core-js/modules/es.array.slice.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

_pushScopeId("data-v-1e32240e");

var _hoisted_1 = {
  class: "date-wrapper"
};

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_authorImg = _resolveComponent("authorImg");

  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["item-wrapper", {
      'active': $options.isMe
    }])
  }, [$options.notEmpty ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createVNode(_component_authorImg, {
    headImg: $props.item.headImg,
    nickName: $props.item.nickName,
    userType: $props.item.isVip,
    source: $props.item.source,
    tags: $props.item.addTime.slice(11, 16)
  }, null, 8, ["headImg", "nickName", "userType", "source", "tags"]), _createElementVNode("div", _hoisted_1, _toDisplayString($props.item.integral), 1)], 64)) : _createCommentVNode("", true)], 2);
}